import { makeAutoObservable } from "mobx";
import { ICompareValueStore } from "./compare-value-factory";
import IntegerBetweenCompareValueField from "../../components/policy-editor/policy-eligibility-card/condition-group-card/condition-builder/condition-field/compare-value-type-fields/integer-between-compare-value-field";

export interface INumberBetweenCompareValue {
    from: number;
    to?: number;
}

class IntegerBetweenCompareValueStore implements ICompareValueStore<INumberBetweenCompareValue> {
    private _model: INumberBetweenCompareValue = {} as INumberBetweenCompareValue;
    private _changes: Partial<INumberBetweenCompareValue> = {};
    private _uncommittedChanges: Partial<INumberBetweenCompareValue> = {};

    constructor(compareValue?: string) {
        makeAutoObservable(this);
        if (compareValue) {
            this._model = this._deserializeModel(compareValue);
        }
    }

    public onOperatorChanged(): void {
    }

    public setChanges(changes?: string) {
        if (changes) {
            this._changes = this._deserializeModel(changes);
        }
    }

    get Component() {
        return IntegerBetweenCompareValueField;
    }

    private _deserializeModel(compareValue: string): INumberBetweenCompareValue {
        let model = {} as INumberBetweenCompareValue;
        try {
            model = JSON.parse(compareValue);
        }
        catch(e) {
            /** should never happen */
            console.error(`invalid condition's compare value from DB: ${compareValue}`);
        }
        return model;
    }

    public get from() {
        return this._uncommittedChanges.from ?? this._changes.from ?? this._model.from;
    }

    public get to() {
        return this._uncommittedChanges.to ?? this._changes.to ?? this._model.to;
    }

    public setFrom(v: number) {
        this._uncommittedChanges.from = v;
    }

    public setTo(v: number) {
        this._uncommittedChanges.to = v;
    }

    public commitChanges(): void {
        this._changes = {...this._changes, ...this._uncommittedChanges};
        this._clearUnneededChanges();
    }

    public discardUncommittedChanges(): void {
        this._uncommittedChanges = {};
    }

    public hasChanges(): boolean {
        return Object.values(this._changes).length > 0;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public getUpdatedModel(): string|undefined {
        const updatedModel = JSON.stringify({ ...this._model, ...this._changes });
        if (updatedModel === JSON.stringify({})) {
            return undefined;
        }
        return updatedModel;
    }

    public getUncommittedChanges() {
        return { ...this._model, ...this._changes, ...this._uncommittedChanges };
    }

    private _clearUnneededChanges() {
        Object.keys(this._changes).forEach(key => {
            const theKey = key as keyof INumberBetweenCompareValue;
            if (this._changes[theKey] === this._model?.[theKey]) {
                delete this._changes[theKey];
            }
        });
    }
}

export default IntegerBetweenCompareValueStore;
